import { render, staticRenderFns } from "./liveBroadcastLanding.vue?vue&type=template&id=27a9fe43&scoped=true"
import script from "./liveBroadcastLanding.vue?vue&type=script&lang=js"
export * from "./liveBroadcastLanding.vue?vue&type=script&lang=js"
import style0 from "./liveBroadcastLanding.vue?vue&type=style&index=0&id=27a9fe43&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a9fe43",
  null
  
)

export default component.exports